// extracted by mini-css-extract-plugin
module.exports = {"titledLogo":"TitledLogo_titledLogo__T6nAi"};